import { GridColDef } from '@mui/x-data-grid';
import { MovementHistory } from '../../../../interfaces/Stocks/movementsHistory';

export const useMovementsHistoryColumns = () => {

  const columnsMovementsHistory: GridColDef<MovementHistory>[] = [];

  return {
    columnsMovementsHistory,
  }
}
